




























import _ from 'lodash'
import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import Getsudo from '@/tcw/domain/Getsudo'
import {
  ApiErrorHandle,
  ApiGeneralObjectArrayPayload,
  ApiGeneralPayload,
  ApiGeneralSinglePayload,
  ApiPayloadValueType
} from '@/tcw/api/types'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import * as ApiPath from '@/tcw/constant/ApiPath'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'

@Component
export default class TeishutsuBrowse extends Mixins(DataGetComponent) {
  @Prop({ required: true, default: '' })
  protected userId!: number | string
  @Prop({ type: Getsudo, default: () => Getsudo.now() })
  private getsudo!: Getsudo

  private response: ApiGeneralSinglePayload | null = null

  get teishutsu(): ApiGeneralSinglePayload {
    return this.response ? this.response : {}
  }

  get teishutsuGetsudo(): string | null {
    return this.du.convertDateStrToStr(this.teishutsu?.teishutsuGetsudo as string, 'YYYY年MM月')
  }

  get apiPath(): string {
    return ApiPath.buildPath(ApiPath.Paths.TeishutsuOther.get, {
      year: this.getsudo.yearValue,
      month: this.getsudo.monthValue,
      userId: this.userId
    })
  }
  get teishutsusha(): ApiPayloadValueType {
    return this.teishutsu.teishutsusha ? this.teishutsu.teishutsusha : {}
  }
  get statusStr(): string {
    let statusStr = `${this.teishutsu.statusName}`
    if (this.teishutsu.status === '1') {
      statusStr += ` ステップ${Number(this.teishutsu.genzaiLevel)}`
    }
    return statusStr
  }

  get shouninUserNames(): string {
    const shouninUserList = this.teishutsu.shouninUserList as ApiGeneralObjectArrayPayload
    if (!_.isArray(shouninUserList)) {
      return ''
    }
    const shouninUserNameList = shouninUserList.map(shounin => shounin.userName)
    return shouninUserNameList.join(',')
  }

  get handleApiError(): ApiErrorHandle {
    return {
      [ERR_CODE_WEB_API_NOT_FOUND]: () => {
        this.failedLoad()
        return Promise.resolve(true)
      }
    }
  }

  @Emit()
  private loaded(_teishutsu: ApiGeneralSinglePayload) {
    //
  }
  @Emit()
  private failedLoad() {
    //
  }
  protected responseInitWebApi(response: ApiGeneralPayload): void {
    if(response == null){
      this.failedLoad()
    }
    if (!_.isArray(response)) {
      this.response = response
    }
  }
  protected async afterProc(): Promise<void> {
    this.loaded(this.teishutsu)
  }
}
